import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: "What products does Adins International Pvt Ltd manufacture?",
    answer: `We specialize in manufacturing premium pet foods and nutritional supplements for dogs and cats, including:
- Probiotic Powders
- Pet Supplements
- Omega-3 Soft Gels
- Milk Powders for Puppies
- Calming Chews
- Himalayan Yak Milk Chews
- Vegetarian Dog Foods and Treats
- Pet food

We also offer custom formulations to meet specific market needs.`,
  },
  {
    question: "Do you offer OEM/ODM services for private labels?",
    answer: `✅ Yes.
We provide full OEM (Original Equipment Manufacturer) and ODM (Original Design Manufacturer) services.

Buyers can customize:
- Product formulations
- Packaging design
- Label branding
- Bulk packaging and retail packaging

We support startups and established brands with low MOQ options and fast turnaround times.`,
  },
  {
    question: "What certifications do your products comply with?",
    answer: `Our manufacturing facility follows GMP, ISO, HACCP, and FDA-approved standards (as applicable).

We ensure that all pet supplements are:
- Non-GMO
- Cruelty-Free
- Free from artificial preservatives and colors
- Veterinarian-reviewed and safe for daily use`,
  },
  {
    question: "What is your minimum order quantity (MOQ)?",
    answer: `Our MOQ is flexible based on product type:

- For bulk/private label orders: Starting from 500 units
- For wholesale stockists: Smaller trial orders can be discussed

We are open to negotiating MOQs depending on buyer needs and partnership potential.`,
  },
  {
    question: "Can I get product samples before placing a bulk order?",
    answer: `✅ Yes.

Samples are available upon request. We encourage buyers to evaluate product quality before confirming bulk or private-label production.`,
  },
  {
    question: "What are your packaging options?",
    answer: `We offer a wide range of packaging:
- Jars, Pouches, Sachets, Boxes
- Custom eco-friendly packaging
- Retail-ready packaging with barcodes and QR codes
- Bulk packaging for distributors

Custom branding and design services are available for all packaging types.`,
  },
  {
    question: "How long does production and delivery take?",
    answer: `- Production time for private-label orders: 15–30 days (depending on the order size and customization)
- Shipping options: Air Freight, Sea Cargo, Express Courier (DHL/FedEx)
- Dispatch for ready stock: Within 3–5 business days

We provide tracking updates and estimated delivery schedules for all shipments.`,
  },
  {
    question: "What payment methods do you accept?",
    answer: `We accept:
- Bank Wire Transfers (TT)
- PayPal (for sample orders)

Other secure international payment methods can be discussed.`,
  },
  {
    question: "Which countries do you export to?",
    answer: `We export globally with strong focus markets in:
- USA
- Europe (Germany, Spain, France, Italy, etc.)
- Middle East
- Southeast Asia
- Australia
- Africa

We are continuously expanding our network of distributors and retail partners.`,
  },
  {
    question: "How can I become a distributor or wholesale partner?",
    answer: `Please contact our Sales Team at:
📧 sales.adinsinternational@gmail.com  
📞 9151816021

We’ll guide you through our partnership models, distributor pricing, marketing support, and exclusive benefits.`,
  },
];

const FAQs: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-6 text-center">
          Frequently Asked Questions (FAQs)
        </h2>
        <div className="space-y-4 mt-16">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-lg p-4 flex flex-col"
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="lg:text-lg font-semibold">{faq.question}</h3>
                <span className="text-gray-600">
                  {openIndex === index ? (
                    <FaChevronUp className="h-5 w-5" />
                  ) : (
                    <FaChevronDown className="h-5 w-5" />
                  )}
                </span>
              </div>
              {openIndex === index && (
                <p className="mt-2 text-gray-700 whitespace-pre-line text-left sm:text-sm ">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
